import styled, { DefaultTheme } from 'styled-components'

export interface TrProps {
  backgroundColor?: keyof DefaultTheme['colors']
}

export const Tr = styled.tr<Partial<TrProps>>(({ theme, backgroundColor }) => ({
  backgroundColor: backgroundColor ? theme.colors[backgroundColor] : undefined,
}))
